import { API_BASE_URLS } from "./apiConfig";
import { store } from "../store/store";

export const getApplications = async () => {
  try {
    const state = store.getState();
    const accessToken = state.auth.accessToken;

    //const response = await fetch(`${API_BASE_URLS.ADMIN_SERVICE}/adminreportservice/v1/application/all`);
    const response = await fetch(
      `${API_BASE_URLS.ADMIN_SERVICE}/adminreportservice/v1/application/all`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-TenantID": "napid_auth",
          Authorization: accessToken, // Include access token
        },
      }
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = await response.json();
    return data;
  } catch (error) {
    return [];
  }
};
export const fetchHomepageData = async () => {
  try {
    //const response = await fetch(`${API_BASE_URLS.ADMIN_SERVICE}/adminreportservice/v1/homepage`);
    const state = store.getState();
    const accessToken = state.auth.accessToken;
    const response = await fetch(
      `${API_BASE_URLS.ADMIN_SERVICE}/adminreportservice/v1/homepage`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-TenantID": "napid_auth",
          Authorization: accessToken, // Include access token
        },
      }
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = await response.json();
    return data;
  } catch (error) {
    return [];
  }
};
export const fetchApplicationMessages = async () => {
  try {
    const state = store.getState();
    const accessToken = state.auth.accessToken;

    const response = await fetch(
      `${API_BASE_URLS.ADMIN_SERVICE}/adminreportservice/v1/adminreport/all/jstext`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-TenantID": "napid_auth",
          Authorization: accessToken, // Include access token
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch messages: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};
export const fetchRegistrationData = async () => {
  try {
    const state = store.getState();
    const accessToken = state.auth.accessToken;
    const response = await fetch(
      `${API_BASE_URLS.CLIENT_SERVICE}/client/v1/user/timeconfiguration`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-TenantID": "napid_auth",
          Authorization: accessToken, // Include access token
        },
      }
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = await response.json();
    return data;
  } catch (error) {
    return [];
  }
};
// Function to fetch applications
export const fetchApplications = async () => {
  try {
    //const response = await fetch(`${API_BASE_URL}/adminreportservice/v1/admin/application/all`, {
    const state = store.getState();
    const accessToken = state.auth.accessToken;
    const response = await fetch(
      `http://192.168.0.109:8087/adminreportservice/v1/application/transactiontime/all`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-TenantID": "napid_auth",
          Authorization: accessToken,
        },
      }
    );

    if (!response.ok) {
      const errorText = await response.text(); // Fetch error response body for debugging

      throw new Error(
        `Failed to fetch applications: ${response.status} ${response.statusText}`
      );
    }

    const result = await response.json();

    return result;
  } catch (error) {
    throw error;
  }
};
export const getAllApps = async () => {
  try {
    const state = store.getState();
    const accessToken = state.auth.accessToken;
    const response = await fetch(
      `${API_BASE_URLS.CLIENT_SERVICE}/client/v1/user/allapplicationname`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    if (!response.ok) {
      throw new Error(
        `Failed to fetch roles: ${response.status} ${response.statusText}`
      );
    }

    const roles = await response.json();

    // Transforming response data as necessary, if the response is an array like: [[2, "SUPER_ADMIN"], ...]
    return roles;
  } catch (error) {
    throw error;
  }
};

export const getAllRoles = async () => {
  try {
    const state = store.getState();
    const accessToken = state.auth.accessToken;
    const response = await fetch(
      `${API_BASE_URLS.CLIENT_SERVICE}/client/v1/user/role/all`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-TenantID": "napid_auth",
          Authorization: accessToken,
        },
      }
    );

    if (!response.ok) {
      throw new Error(
        `Failed to fetch roles: ${response.status} ${response.statusText}`
      );
    }

    const roles = await response.json();

    // Transforming response data as necessary, if the response is an array like: [[2, "SUPER_ADMIN"], ...]
    return roles;
  } catch (error) {
    throw error;
  }
};
export const getAdmins = async () => {
  try {
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    const response = await fetch(
      `${API_BASE_URLS.CLIENT_SERVICE}/client/v1/user/all`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-TenantID": "napid_auth",
          Authorization: accessToken,
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        `Failed to fetch admins: ${errorData.message || response.statusText}`
      );
    }

    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
};
export const getAllSubscriptions = async () => {
  try {
    const state = store.getState();
    const accessToken = state.auth.accessToken;
    const response = await fetch(
      `${API_BASE_URLS.CLIENT_SERVICE}/client/v1/subscription`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error("Failed to fetch subscriptions");
    }
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const getDefaultCardImage = async () => {
  try {
    const state = store.getState();
    const accessToken = state.auth.accessToken;
    const response = await fetch(
      `${API_BASE_URLS.CLIENT_SERVICE}/client/v1/user/logo/cardimage`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-TenantID": "napid_auth",
          Authorization: accessToken, // Include the access token here
        },
      }
    );
    if (!response.ok) {
      throw new Error("Failed to fetch default card image");
    }
    const data = await response.json();
    return data.image; // This is the base64 string
  } catch (error) {
    throw error;
  }
};
export const getClientLogo = async () => {
  try {
    const state = store.getState();
    const accessToken = state.auth.accessToken;
    const response = await fetch(
      `${API_BASE_URLS.CLIENT_SERVICE}/client/v1/user/logo/clientlogo`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-TenantID": "napid_auth",
          Authorization: accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error("Failed to fetch default card image");
    }
    const data = await response.json();
    return data.image;
  } catch (error) {
    throw error;
  }
};
export const fetchApplicationsjs = async () => {
  try {
    const state = store.getState();
    const accessToken = state.auth.accessToken;
    //const response = await fetch(`${API_BASE_URL}/adminreportservice/v1/admin/applicationname/all`, {
    const response = await fetch(
      `${API_BASE_URLS.ADMIN_SERVICE}/adminreportservice/v1/application/jslogo/all `,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json", // Specify the content type if needed
          Authorization: accessToken, // Include the access token here
        },
      }
    );

    if (!response.ok) {
      // Handle non-2xx HTTP responses
      const errorText = await response.text();

      throw new Error(
        `Failed to fetch applications: ${response.status} ${response.statusText}`
      );
    }

    // Parse the JSON response
    const data = await response.json();
    return data;
  } catch (error) {
    return []; // Return an empty array on error
  }
};

export const getSmsNumber = async (selectedType) => {
  try {
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    const response = await fetch(
      `${API_BASE_URLS.CLIENT_SERVICE}/client/v1/sms/sendernumber/apptype/${selectedType}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        `Failed to fetch admins: ${errorData.message || response.statusText}`
      );
    }

    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
};

export const getSmsNumbers = async (dataType) => {
  try {
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    const response = await fetch(
      `${API_BASE_URLS.CLIENT_SERVICE}/client/v1/sms/sendernumber/apptype/${dataType}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        `Failed to fetch admins: ${errorData.message || response.statusText}`
      );
    }

    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
};

export const getCountry = async () => {
  try {
    console.log("api called");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    const response = await fetch(
      `${API_BASE_URLS.CLIENT_SERVICE}/client/v1/user/countryinfodetails`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        `Failed to fetch admins: ${errorData.message || response.statusText}`
      );
    }

    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
};

// New function to get whitelist IP details
export const getWhitelistIps = async () => {
  try {
    console.log("Fetching whitelist IP details");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    const response = await fetch(
      `${API_BASE_URLS.CLIENT_SERVICE}/client/v1/user/whitelist-ips`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        `Failed to fetch whitelist IPs: ${
          errorData.message || response.statusText
        }`
      );
    }

    const result = await response.json();
    return result; // Return the API response as JSON
  } catch (error) {
    console.error("Error fetching whitelist IPs:", error);
    throw error; // Rethrow error for further handling
  }
};

// Function to get blacklist IP details
export const getBlacklistIps = async () => {
  try {
    console.log("Fetching blacklist IP details");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    const response = await fetch(
      `${API_BASE_URLS.CLIENT_SERVICE}/client/v1/user/blacklist-ips`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        `Failed to fetch blacklist IPs: ${
          errorData.message || response.statusText
        }`
      );
    }

    const result = await response.json();
    return result; // Return the API response as JSON
  } catch (error) {
    console.error("Error fetching blacklist IPs:", error);
    throw error; // Rethrow error for further handling
  }
};

export const getHistorySubscription = async () => {
  try {
    console.log("api called");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    //const response = await fetch(`${API_BASE_URLS.CLIENT_SERVICE}/client/v1/subscription/history`, {
    const response = await fetch(
      `${API_BASE_URLS.CLIENT_SERVICE}/client/v1/subscription/history`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        `Failed to fetch admins: ${errorData.message || response.statusText}`
      );
    }

    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
};

// Fetch data for the second API
export const fetchApplicationReport2 = async () => {
  try {
    const state = store.getState();
    const accessToken = state.auth.accessToken;

    const response = await fetch(
      `https://192.168.0.109:8087/adminreportservice/v1/application/all`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken, // Include access token
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch application reports: ${response.statusText}`);
    }

    const data = await response.json();
    return data; // Assuming data is an array
  } catch (error) {
    console.error("Error fetching application reports:", error);
    throw error;
  }
};


export const fetchTransactionHistory = async (applicationId, fromDate, toDate, page, size) => {
  try {
    const state = store.getState();
    const accessToken = state.auth.accessToken;

    const response = await fetch(
      `http://192.168.0.109:8087/adminreportservice/v1/alltransactionhistory/applicationid/${applicationId}/${fromDate}/${toDate}/${page}/${size}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken, // Include access token
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch transaction history: ${response.statusText}`);
    }

    const data = await response.json();
    return data; // Assuming data is the response object
  } catch (error) {
    console.error("Error fetching transaction history:", error);
    throw error;
  }
};
export const fetchNonCustomerData = async (
  applicationId,
  fromDate,
  toDate,
  page,
  size
) => {
  try {
    const state = store.getState();
    const accessToken = state.auth.accessToken;

    const response = await fetch(
      `http://192.168.0.109:8087/adminreportservice/v1/noncustomer/transactionhistory/applicationid/${applicationId}/${fromDate}/${toDate}/${page}/${size}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken, // Include access token
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch user data: ${response.statusText}`);
    }

    const data = await response.json();
    return data; // Assuming data is the response object
  } catch (error) {
    console.error("Error fetching user data:", error);
    throw error;
  }
};

export const generateNonCustomerPDF = async (applicationid,fromDate,toDate) => {
  try {
    console.log("api called");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    // Make the request to generate PDF
    const response = await fetch(
      `http://192.168.0.109:8087/adminreportservice/v1/generatepdf/noncustomer/transactionhistory/${applicationid}/${fromDate}/${toDate}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    if (response.ok) {
      const blob = await response.blob(); // Convert response to a Blob object
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "report.pdf"; // Desired file name
      document.body.appendChild(link);

      // Programmatically click the link
      link.click();

      // Cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } else {
      console.error("Failed to download PDF. Status:", response.status);
    }
  } catch (error) {
    throw error;
  }
};
export const generateNonCustomerExcel = async (applicationid,fromDate,toDate) => {
  try {
    console.log("api called");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    // Make the request to generate PDF
    const response = await fetch(
      `http://192.168.0.109:8087/adminreportservice/v1/excelformat/noncustomer/transactionhistory/${applicationid}/${fromDate}/${toDate}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    if (response.ok) {
      const blob = await response.blob(); // Convert response to a Blob object
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "report.xlsx"; // Desired file name
      document.body.appendChild(link);

      // Programmatically click the link
      link.click();

      // Cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } else {
      console.error("Failed to download PDF. Status:", response.status);
    }
  } catch (error) {
    throw error;
  }
};
export const generateUserDataPDF = async (applicationid,fromDate,toDate) => {
  try {
    console.log("api called");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    // Request to generate user data PDF
    const response = await fetch(
      `http://192.168.0.109:8087/adminreportservice/v1/generatepdf/searchbycustomerdata/${applicationid}/${fromDate}/${toDate}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );


    if (response.ok) {
      const blob = await response.blob(); // Convert response to a Blob object
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "report.pdf"; // Desired file name
      document.body.appendChild(link);

      // Programmatically click the link
      link.click();

      // Cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } else {
      console.error("Failed to download PDF. Status:", response.status);
    }

  } catch (error) {
    throw error;
  }
};

// Generate User Data PDF
export const generateUserDataExcel = async (applicationid,fromDate,toDate) => {
  try {
    console.log("api called");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    // Request to generate user data PDF
    const response = await fetch(
     
       `http://192.168.0.109:8087/adminreportservice/v1/excelformat/searchbycustomerdata/${applicationid}/${fromDate}/${toDate}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );



if (response.ok) {
  const blob = await response.blob(); // Convert response to a Blob object
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "report.xlsx"; // Change to .xlsx

  document.body.appendChild(link);
  link.click(); // Trigger download

  // Cleanup
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
} else {
  console.error("Failed to download Excel report. Status:", response.status);
}
  } catch (error) {
    throw error;
  }
};


export const getMobileNumberPdf = async (
  mobileNo,
  applicationid,
  fromdate,
  todate
) => {
  try {
    console.log("api called");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    const response = await fetch(
      `http://192.168.0.109:8087/adminreportservice/v1/generatepdf/searchbymobileno/${mobileNo}/${applicationid}/${fromdate}/${todate}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    if (response.ok) {
      const blob = await response.blob(); // Convert response to a Blob object
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "report.pdf"; // Desired file name
      document.body.appendChild(link);

      // Programmatically click the link
      link.click();

      // Cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } else {
      console.error("Failed to download PDF. Status:", response.status);
    }
  } catch (error) {
    throw error;
  }
};
export const getMobileNumberExcel = async (
  mobileNo,
  applicationid,
  fromdate,
  todate
) => {
  try {
    console.log("api called");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    const response = await fetch(
      `http://192.168.0.109:8087/adminreportservice/v1/excelformat/searchbymobileno/${mobileNo}/${applicationid}/${fromdate}/${todate}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    if (response.ok) {
      const blob = await response.blob(); // Convert response to a Blob object
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "report.xlsx"; // Change to .xlsx
      document.body.appendChild(link);

      // Programmatically click the link
      link.click();

      // Cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } else {
      console.error("Failed to download PDF. Status:", response.status);
    }
  } catch (error) {
    throw error;
  }
};

export const getMobileDetails = async (mobileNo, pageno, size) => {
  try {
    console.log("api called");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    const response = await fetch(
      `http://192.168.0.109:8087/adminreportservice/v1/searchbymobileno/mobileuser/${mobileNo}/${pageno}/${size} `,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
};
export const getMobilePdf = async (mobileNo) => {
  try {
    console.log("api called");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    const response = await fetch(
      `http://192.168.0.109:8087/adminreportservice/v1/generatepdf/searchbymobileno/${mobileNo}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    if (response.ok) {
      const blob = await response.blob(); // Convert response to a Blob object
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "report.pdf"; // Desired file name
      document.body.appendChild(link);

      // Programmatically click the link
      link.click();

      // Cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } else {
      console.error("Failed to download PDF. Status:", response.status);
    }
  } catch (error) {
    throw error;
  }
};
export const getMobileExcel = async (mobileNo) => {
  try {
    console.log("api called");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    const response = await fetch(
      `http://192.168.0.109:8087/adminreportservice/v1/excelformat/searchbymobileno/${mobileNo}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    if (response.ok) {
      const blob = await response.blob(); // Convert response to a Blob object
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "report.xlsx"; // Desired file name
      document.body.appendChild(link);

      // Programmatically click the link
      link.click();

      // Cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } else {
      console.error("Failed to download PDF. Status:", response.status);
    }
  } catch (error) {
    throw error;
  }
};

export const getApplicationReports = async () => {
  try {
    console.log("api called");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    const response = await fetch(
      `http://192.168.0.109:8087/adminreportservice/v1/allapplication`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    // if (!response.ok) {
    //   const errorData = await response.json();
    //   throw new Error(
    //     `Failed to fetch admins: ${errorData.message || response.statusText}`
    //   );
    // }

    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
};
export const getIdCardNumberEmail = async (
  digitalid,
  applicationid,
  fromdate,
  todate,
  page,
  size
 
) => {
  try {
    console.log("api called");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    const response = await fetch(
      `http://192.168.0.109:8087/adminreportservice/v1/searchbyid/${digitalid}/${applicationid}/${fromdate}/${todate}/${page}/${size} `,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    // if (!response.ok) {
    //   const errorData = await response.json();
    //   throw new Error(
    //     `Failed to fetch admins: ${errorData.message || response.statusText}`
    //   );
    // }

    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
};
export const getIdCardNumberEmailTransaction = async (
  digitalid,
  applicationid,
  fromdate,
  todate,
  pages,
  size,
  
) => {
  try {
    console.log("api called");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    const response = await fetch(
      `http://192.168.0.109:8087/adminreportservice/v1/searchbyid/transaction/${digitalid}/${applicationid}/${fromdate}/${todate}/${pages}/${size} `,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    // if (!response.ok) {
    //   const errorData = await response.json();
    //   throw new Error(
    //     `Failed to fetch admins: ${errorData.message || response.statusText}`
    //   );
    // }

    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
};
export const getMobileNumber = async (
  mobileno,
  applicationid,
  fromdate,
  todate,
  page,
  size,
 
) => {
  try {
    console.log("api called");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    const response = await fetch(
      `http://192.168.0.109:8087/adminreportservice/v1/searchbymobilenumber/${mobileno}/${applicationid}/${fromdate}/${todate}/${page}/${size} `,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    // if (!response.ok) {
    //   const errorData = await response.json();
    //   throw new Error(
    //     `Failed to fetch admins: ${errorData.message || response.statusText}`
    //   );
    // }

    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
};
export const getMobileNumberTransaction = async (
  mobileno,
  applicationid,
  fromdate,
  todate,
  page,
  size,
  
) => {
  try {
    console.log("api called");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    const response = await fetch(
      `http://192.168.0.109:8087/adminreportservice/v1/searchbymobilenumber/transaction/${mobileno}/${applicationid}/${fromdate}/${todate}/${page}/${size} `,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    // if (!response.ok) {
    //   const errorData = await response.json();
    //   throw new Error(
    //     `Failed to fetch admins: ${errorData.message || response.statusText}`
    //   );
    // }

    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
};
export const getCountryCode = async () => {
  try {
    console.log("api called");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    const response = await fetch(
      `http://192.168.0.109:8087/adminreportservice/v1/allcountrycode`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    // if (!response.ok) {
    //   const errorData = await response.json();
    //   throw new Error(
    //     `Failed to fetch admins: ${errorData.message || response.statusText}`
    //   );
    // }

    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
};
export const getIdPdf = async (digitalid, applicationid, fromdate, todate) => {
  try {
    console.log("api called");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    const response = await fetch(
      `http://192.168.0.109:8087/adminreportservice/v1/generatepdf/searchbydigitalid/${digitalid}/${applicationid}/${fromdate}/${todate}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    if (response.ok) {
      const blob = await response.blob(); // Convert response to a Blob object
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "report.pdf"; // Desired file name
      document.body.appendChild(link);

      // Programmatically click the link
      link.click();

      // Cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } else {
      console.error("Failed to download PDF. Status:", response.status);
    }
  } catch (error) {
    throw error;
  }
};
export const getIdExcel = async (digitalid, applicationid, fromdate, todate) => {
  try {
    console.log("api called");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    const response = await fetch(
      `http://192.168.0.109:8087/adminreportservice/v1/excelformat/searchbydigitalid/${digitalid}/${applicationid}/${fromdate}/${todate}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    if (response.ok) {
      const blob = await response.blob(); // Convert response to a Blob object
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "report.xlsx"; // Change to .xlsx
    
      document.body.appendChild(link);
      link.click(); // Trigger download
    
      // Cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } else {
      console.error("Failed to download Excel report. Status:", response.status);
    }
  } catch (error) {
    throw error;
  }
};
export const getIdPdfTransaction = async (
  digitalid,
  applicationid,
  fromdate,
  todate
) => {
  try {
    console.log("api called");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    const response = await fetch(
      `http://192.168.0.109:8087/adminreportservice/v1/generatepdf/searchbydigitalid/transaction/${digitalid}/${applicationid}/${fromdate}/${todate}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    if (response.ok) {
      const blob = await response.blob(); // Convert response to a Blob object
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "report.pdf"; // Desired file name
      document.body.appendChild(link);

      // Programmatically click the link
      link.click();

      // Cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } else {
      console.error("Failed to download PDF. Status:", response.status);
    }
  } catch (error) {
    throw error;
  }
};
export const getIdExcelTransaction = async (
  digitalid,
  applicationid,
  fromdate,
  todate
) => {
  try {
    console.log("api called");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    const response = await fetch(
      `http://192.168.0.109:8087/adminreportservice/v1/excelformat/searchbydigitalid/transaction/${digitalid}/${applicationid}/${fromdate}/${todate}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    if (response.ok) {
      const blob = await response.blob(); // Convert response to a Blob object
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "report.xlsx"; // Change to .xlsx
    
      document.body.appendChild(link);
      link.click(); // Trigger download
    
      // Cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } else {
      console.error("Failed to download Excel report. Status:", response.status);
    }
  } catch (error) {
    throw error;
  }
};

export const getMobileNumberPdfTransaction = async (
  mobileNo,
  applicationid,
  fromdate,
  todate
) => {
  try {
    console.log("api called");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    const response = await fetch(
      `http://192.168.0.109:8087/adminreportservice/v1/generatepdf/searchbymobileno/transaction/${mobileNo}/${applicationid}/${fromdate}/${todate}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    if (response.ok) {
      const blob = await response.blob(); // Convert response to a Blob object
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "report.pdf"; // Desired file name
      document.body.appendChild(link);

      // Programmatically click the link
      link.click();

      // Cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } else {
      console.error("Failed to download PDF. Status:", response.status);
    }
  } catch (error) {
    throw error;
  }
};
export const getMobileNumberExcelTransaction = async (
  mobileNo,
  applicationid,
  fromdate,
  todate
) => {
  try {
    console.log("api called");
    const state = store.getState();
    let accessToken = state.auth.accessToken;

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    const response = await fetch(
      `http://192.168.0.109:8087/adminreportservice/v1/excelformat/searchbymobileno/transaction/${mobileNo}/${applicationid}/${fromdate}/${todate}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    if (response.ok) {
      const blob = await response.blob(); // Convert response to a Blob object
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${response}.xlsx`; // Change to .xlsx
      document.body.appendChild(link);

      // Programmatically click the link
      link.click();

      // Cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } else {
      console.error("Failed to download PDF. Status:", response.status);
    }
  } catch (error) {
    throw error;
  }
};


export const getNapidLogo = async () => {
  try {
    const state = store.getState();
    const accessToken = state.auth.accessToken;
    const response = await fetch(
      `http://192.168.0.198:8080/client/v1/user/logo/napidLogo`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-TenantID": "napid_auth",
          Authorization: accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error("Failed to fetch default card image");
    }
    const data = await response.json();
    return data.image;
  } catch (error) {
    throw error;
  }
};

